import { Button, Container, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/'); // Navigate back to the homepage or any other appropriate route
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        mt: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '80vh',
        justifyContent: 'center',
      }}
    >
      <Typography variant="h1" component="h1" gutterBottom>
        404 Page Not Found
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: '#fff' }}>
        Sorry, the page you are looking for doesn’t exist or has been moved.
      </Typography>
      <Button variant="contained" onClick={handleBack}>
        Go Back Home
      </Button>
    </Container>
  );
};
